import { render, staticRenderFns } from "./priceManage3Q.vue?vue&type=template&id=dfbc0c12&scoped=true"
import script from "./priceManage3Q.vue?vue&type=script&lang=js"
export * from "./priceManage3Q.vue?vue&type=script&lang=js"
import style0 from "./priceManage3Q.vue?vue&type=style&index=0&id=dfbc0c12&prod&scoped=true&lang=css"
import style1 from "./priceManage3Q.vue?vue&type=style&index=1&id=dfbc0c12&prod&lang=css"
import style2 from "./priceManage3Q.vue?vue&type=style&index=2&id=dfbc0c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbc0c12",
  null
  
)

export default component.exports